export default __webpack_public_path__ + "static/map-alt-6e9d01a132b093ade5e6c962e5adc84c.png";